export default __webpack_public_path__ + "static/media/CASalesLogo.4d4d5876.svg";